var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"file-content-container"},[_c('v-layout',[_c('v-flex',{attrs:{"mb2":""}},[_c('v-img',{staticClass:"mb-5",attrs:{"src":_vm.logo,"width":"320","data-cy":"logo"}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }